import { render, staticRenderFns } from "./ExcuseList.vue?vue&type=template&id=a05fab12&scoped=true&"
import script from "./ExcuseList.vue?vue&type=script&lang=js&"
export * from "./ExcuseList.vue?vue&type=script&lang=js&"
import style0 from "./ExcuseList.vue?vue&type=style&index=0&id=a05fab12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05fab12",
  null
  
)

export default component.exports